import { useEffect, useRef, useState } from "react";
import { Select } from "antd";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import { CustomInput, CustomSelect, ErrorText } from "./ui";
import CustomModal from "./customModal/customModal";
import {
  validateFormHandler,
  validateLiveField,
} from "../utils/validations/validateForm";
import ModalFooter from "./customModal/modalFooter";
const { Option } = Select;

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AddSubUser = ({ onSuccess, onCancel }) => {
  const view = process.env.REACT_APP_ACCESS_VIEW;
  const edit = process.env.REACT_APP_ACCESS_EDIT;
  const role = process.env.REACT_APP_USER_ROLE_ID;
  const baseCurrency = localStorage.getItem("baseCurrency");
  const parentId = localStorage.getItem("id");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState('');
  const [access, setAccess] = useState(view);
  const [loading, setLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [milestones, setMilestones] = useState([]);
  const { projectList } = useSelector((state) => state.app);
  const [milestoneList, setMilestoneList] = useState([]);
  const [errors, setErrors] = useState({});
  const [showFooterShadow, setShowFooterShadow] = useState(false);
  const contentRef = useRef(null);

  const handleProjectChange = (value) => {
    setProjects(value);

    if (value.length > 0 && projectList && projectList.length > 0) {
      const lastProjectId = value[value.length - 1];
      if (lastProjectId !== "All") {
        fetchMilestones(lastProjectId);
      } else {
        setMilestoneList([]);
      }
    } else {
      setMilestoneList([]);
    }
  };

  const handleMilestoneChange = (value) => {
    setMilestones(value);
  };

  const fetchMilestones = async (projectId) => {
    try {
      const response = await api.get(
        `${getRoute(
          "users",
          "admin",
          "projects",
          false,
          false,
          "milestone"
        )}?projectId=${projectId}`
      );
      setMilestoneList((prev) => {
        const existingIds = new Set(prev.map((m) => m._id));
        const newMilestones = response.data.filter(
          (m) => !existingIds.has(m._id)
        );
        return [...prev, ...newMilestones];
      });
    } catch (error) {
      toast.error("Error fetching milestones", error);
      return null;
    }
  };
  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);

    const error = validateLiveField("name", value);

    setErrors((prev) => ({ ...prev, name: error || undefined }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateFormHandler({
      name,
      email,
      // password,
      milestones,
      projects,
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      setLoading(true);

      const response = await fetch(`${API_BASE_URL}/api/v1/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          baseCurrency,
          milestones,
          // password,
          role,
          access,
          parentId,
        }),
      });

      const data = await response.json();

      if (response.status === 201) {
        toast.success("Member added successfully!");
        setName("");
        setEmail("");
        // setPassword('');
        setProjects([]);
        setMilestones([]);
        setAccess("View");

        if (onSuccess) {
          onSuccess();
        }
      } else {
        toast.error(data.error || "Failed to add member");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
      handleCancel();
    }
  };

  const handleCancel = () => {
    setName("");
    setEmail("");
    // setPassword('');
    setProjects([]);
    setMilestones([]);
    setAccess(view);
    if (onCancel) {
      onCancel();
    }
  };
  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkScrollable = () => {
      setShowFooterShadow(el.scrollHeight > el.clientHeight);
    };

    checkScrollable();

    window.addEventListener("resize", checkScrollable);
    return () => window.removeEventListener("resize", checkScrollable);
  }, []);
  return (
    <CustomModal
      modalTitle="Add Member"
      isOpen={onSuccess}
      onClose={handleCancel}
    >
      <form onSubmit={handleSubmit}>
        <div
          ref={contentRef}
          className="w-full mx-auto bg-white max-h-[50vh] scrollbar-hidden font-customFont"
        >
          <CustomInput
            id="name"
            type="text"
            label="Name"
            value={name}
            onChange={handleNameChange}
            placeholder="Enter member name"
            message={errors.name}
            requir="true"
          />
          <div className="mb-4">
            <CustomInput
              id="email"
              type="email"
              label="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (errors.email) {
                  setErrors((prev) => ({ ...prev, email: undefined }));
                }
              }}
              placeholder="Enter email"
              message={errors.email}
              requir="true"
            />
          </div>

          {/* <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="password"
            >
              Password <span className="text-red-500">*</span>
            </label>
            <Input.Password
              id="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (errors.password) {
                  setErrors((prev) => ({...prev, password: undefined}));
                }
              }}
              className="w-full p-2 border rounded-lg"
              placeholder="Enter password"
            />
            <ErrorText message={errors.password} />
          </div> */}

          <div className="mb-4">
            <CustomSelect
              label="Projects"
              value={projects}
              onChange={(e) => {
                handleProjectChange(e);
                if (errors.projects) {
                  setErrors((prev) => ({ ...prev, projects: undefined }));
                }
              }}
              options={projectList.map((pro) => ({
                label: pro?.name,
                value: pro?._id,
              }))}
              multiple
              message={errors.projects}
              useAntd
            />
          </div>
          <div className="mb-4">
            <CustomSelect
              label="Milestones"
              name="milestones"
              value={milestones}
              onChange={(e) => {
                handleMilestoneChange(e);
                if (errors.milestones) {
                  setErrors((prev) => ({ ...prev, milestones: undefined }));
                }
              }}
              multiple
              useAntd
              placeholder="Select milestones"
              options={milestoneList.map((mile) => ({
                value: mile._id,
                label: `${mile.name} - ${mile.project.name}`,
              }))}
              message={errors.milestones}
            />
          </div>

          <div className="mb-4">
            <CustomSelect
              label="Access"
              name="access"
              value={access}
              onChange={setAccess}
              useAntd={true}
              options={[
                { value: view, label: "View" },
                { value: edit, label: "Edit" },
              ]}
            />
          </div>
        </div>

        <ModalFooter
          onCancel={handleCancel}
          isLoading={loading}
          showShadow={showFooterShadow}
        />
      </form>
    </CustomModal>
  );
};

export default AddSubUser;
